// derived from generate-password node/serverside npm package
const RANDOM_BATCH_SIZE = 256;

let randomIndex;
let randomBytes;

function refillRandomBytes() {
  randomIndex = 0;
  randomBytes = new Uint8Array(RANDOM_BATCH_SIZE);
  crypto.getRandomValues(randomBytes);
}

function getNextRandomValue() {
  if (!randomBytes || randomIndex >= randomBytes.length) {
    refillRandomBytes();
  }

  return randomBytes[randomIndex++];
}

function randomNumber(max) {
  let rand = getNextRandomValue();
  while (rand >= 256 - (256 % max)) {
    rand = getNextRandomValue();
  }
  return rand % max;
}

// Character sets
const lowercase = 'abcdefghijklmnopqrstuvwxyz';
const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const numbers = '0123456789';
const symbols = '!@#$%^&*()+_-=}{[]|:;"/?.><,`~';
const similarCharacters = /[ilLI|`oO0]/g;

const strictRules = [
  { name: 'lowercase', rule: /[a-z]/ },
  { name: 'uppercase', rule: /[A-Z]/ },
  { name: 'numbers', rule: /[0-9]/ },
  { name: 'symbols', rule: /[!@#$%^&*()+_\-=}{[\]|:;"/?.><,`~]/ },
];

function generateInternal(options, pool) {
  let password = '';

  for (let i = 0; i < options.length; i++) {
    password += pool[randomNumber(pool.length)];
  }

  if (options.strict) {
    const fitsRules = strictRules.every((rule) => {
      if (options[rule.name] === false) return true;

      if (rule.name === 'symbols' && typeof options.symbols === 'string') {
        const re = new RegExp('[' + options.symbols + ']');
        return re.test(password);
      }

      return rule.rule.test(password);
    });

    if (!fitsRules) return generateInternal(options, pool);
  }

  return password;
}

export function generate(options = {}) {
  if (!Object.prototype.hasOwnProperty.call(options, 'length'))
    options.length = 10;
  if (!Object.prototype.hasOwnProperty.call(options, 'numbers'))
    options.numbers = false;
  if (!Object.prototype.hasOwnProperty.call(options, 'symbols'))
    options.symbols = false;
  if (!Object.prototype.hasOwnProperty.call(options, 'exclude'))
    options.exclude = '';
  if (!Object.prototype.hasOwnProperty.call(options, 'uppercase'))
    options.uppercase = true;
  if (!Object.prototype.hasOwnProperty.call(options, 'lowercase'))
    options.lowercase = true;
  if (
    !Object.prototype.hasOwnProperty.call(options, 'excludeSimilarCharacters')
  )
    options.excludeSimilarCharacters = false;
  if (!Object.prototype.hasOwnProperty.call(options, 'strict'))
    options.strict = false;

  if (options.strict) {
    const minStrictLength =
      (options.lowercase ? 1 : 0) +
      (options.uppercase ? 1 : 0) +
      (options.numbers ? 1 : 0) +
      (options.symbols ? 1 : 0);

    if (minStrictLength > options.length) {
      throw new TypeError('Length must correlate with strict guidelines');
    }
  }

  let pool = '';

  if (options.lowercase) pool += lowercase;
  if (options.uppercase) pool += uppercase;
  if (options.numbers) pool += numbers;

  if (options.symbols) {
    pool += typeof options.symbols === 'string' ? options.symbols : symbols;
  }

  if (!pool) {
    throw new TypeError('At least one rule for pools must be true');
  }

  if (options.excludeSimilarCharacters) {
    pool = pool.replace(similarCharacters, '');
  }

  for (let i = 0; i < options.exclude.length; i++) {
    pool = pool.replace(options.exclude[i], '');
  }

  return generateInternal(options, pool);
}

export function generateMultiple(amount, options) {
  return Array.from({ length: amount }, () => generate(options));
}
